/* eslint-disable import/no-internal-modules */
export * from "./splatFileLoader";
